import { LuHeart } from 'react-icons/lu';
import { getRelationshipEmoji } from '../utils/relationshipEmojis';

const RelationshipOverviewContent = ({ contact, onToggleFavorite, isFavoritePending }) => {
  const emoji = getRelationshipEmoji(contact?.relationship_type);
  const strengthLabel = (() => {
    const value = contact?.relationship_strength;
    if (value === undefined || value === null || value === '') return null;
    if (typeof value === 'number') return value <= 10 ? `${value}/10` : String(value);
    return String(value);
  })();

  return (
    <div className="space-y-4 text-sm text-slate-200">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h2 className="text-xl font-semibold text-slate-50">
            {contact?.first_name} {contact?.last_name}
          </h2>
          <div className="mt-2 flex flex-wrap items-center gap-2">
            {contact?.relationship_type ? (
              <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1">
                <span className="text-base">{emoji}</span>
                <span className="capitalize">{contact.relationship_type}</span>
              </span>
            ) : null}
            {strengthLabel ? (
              <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1">
                <span className="text-slate-300">Strength</span>
                <span className="font-semibold text-slate-50">{strengthLabel}</span>
              </span>
            ) : null}
          </div>
        </div>
        <button
          type="button"
          onClick={onToggleFavorite}
          disabled={isFavoritePending}
          aria-pressed={!!contact?.is_favorite}
          className={`group inline-flex h-10 w-10 items-center justify-center rounded-full transition focus:outline-none focus:ring-2 focus:ring-sky-400/50 ${
            contact?.is_favorite ? 'text-rose-400' : 'text-slate-300 hover:text-rose-300'
          } ${isFavoritePending ? 'opacity-60' : ''}`}
        >
          <LuHeart
            className={`h-5 w-5 transition ${contact?.is_favorite ? 'fill-rose-400 text-rose-400' : ''}`}
          />
          <span className="sr-only">Toggle favorite</span>
        </button>
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <div>
          <p className="text-slate-400">Email</p>
          <p>{contact?.email || '—'}</p>
        </div>
        <div>
          <p className="text-slate-400">Phone</p>
          <p>{contact?.phone || '—'}</p>
        </div>
        <div>
          <p className="text-slate-400">Met When</p>
          <p>{contact?.met_when || '—'}</p>
        </div>
        <div>
          <p className="text-slate-400">Met Where</p>
          <p>{contact?.met_where || '—'}</p>
        </div>
      </div>
    </div>
  );
};

export default RelationshipOverviewContent;
